var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVtexIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M18.8125 0C22.1262 0 24.8125 2.68629 24.8125 6V18C24.8125 21.3137 22.1262 24 18.8125 24H6.8125C3.49879 24 0.8125 21.3137 0.8125 18V6C0.8125 2.68629 3.49879 0 6.8125 0H18.8125Z",
    fill: "#FF4D6C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_841_48217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7641 7.04688H8.30901C7.49818 7.04688 6.97901 7.90438 7.35818 8.61663L8.40468 10.5865H6.50885C6.3887 10.5866 6.27057 10.6175 6.16585 10.6764C6.06166 10.7352 5.9743 10.8198 5.9121 10.922C5.85047 11.0242 5.81627 11.1407 5.81279 11.26C5.80932 11.3794 5.83669 11.4976 5.89226 11.6033L9.25576 17.9377C9.31468 18.0485 9.40335 18.1419 9.51243 18.2072C9.62103 18.2722 9.74521 18.3065 9.87176 18.3065C9.99831 18.3065 10.1225 18.2722 10.2311 18.2072C10.3395 18.142 10.4282 18.0487 10.4878 17.9371L11.4013 16.2262L12.5475 18.3851C12.9506 19.1446 14.0432 19.1458 14.448 18.3875L19.6881 8.57696C20.0585 7.88279 19.5533 7.04688 18.7641 7.04688ZM14.0677 11.2381L11.8078 15.469C11.7681 15.5432 11.7091 15.6053 11.6369 15.6487C11.5646 15.6919 11.482 15.7147 11.3978 15.7147C11.3135 15.7147 11.2309 15.6919 11.1586 15.6487C11.0867 15.6052 11.0278 15.5432 10.9883 15.469L8.75118 11.2568C8.71378 11.1866 8.69521 11.1079 8.69725 11.0283C8.69929 10.9488 8.72189 10.8712 8.76285 10.803C8.80429 10.7348 8.86253 10.6783 8.93201 10.639C9.00147 10.5999 9.07979 10.5792 9.15951 10.579H13.6693C13.747 10.5796 13.8234 10.5996 13.8915 10.6373C13.9587 10.6759 14.0153 10.7306 14.056 10.7965C14.0959 10.863 14.118 10.9386 14.12 11.0161C14.1221 11.0936 14.104 11.1703 14.0677 11.2387V11.2381Z",
    fill: "#FF4D6C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_841_48217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(5.8125 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVtexIcon);
export default __webpack_public_path__ + "static/media/vtex-icon.f5212bd5b00a48d08486b54c430653a1.svg";
export { ForwardRef as ReactComponent };